/**
 * CSRF Token Helper
 * Retrieves Django CSRF token for AJAX requests
 */

/**
 * Get CSRF token from the page
 * First tries hidden input, then falls back to cookie
 * @returns {string|null} CSRF token value
 */
export function getCsrfToken() {
  // First try the hidden input (most reliable)
  const input = document.querySelector('[name=csrfmiddlewaretoken]');
  if (input) return input.value;

  // Fallback to cookie
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, 10) === 'csrftoken=') {
        return decodeURIComponent(cookie.substring(10));
      }
    }
  }
  return null;
}

// Also expose globally for backward compatibility
window.getCsrfToken = getCsrfToken;
